import React from 'react';
import { connect } from 'react-redux';
import './Header.scss';
import getNameFromUrl from '../../scripts/lib/getNameFromUrl';

import LanguageSelector from '../LanguageSelector/LanguageSelector';

const Header = props => {
    let publisherName = '';
    if (props.configuration && props.configuration.publisherName) {
        publisherName = props.configuration.publisherName;
    } else if (window.location && window.location.ancestorOrigins && window.location.ancestorOrigins[0]) {
        publisherName = getNameFromUrl(window.location.ancestorOrigins[0])
    }

    const { configuration } = props;
    let currentLanguage = props.currentLanguage;
    if(currentLanguage && configuration && configuration.domesticLanguages && configuration.domesticLanguages[currentLanguage.code+"-dom"]){
        currentLanguage = configuration.domesticLanguages[currentLanguage.code+"-dom"];
        debugger;
    }

    return (
        <div id="header">
            <h1>
                {currentLanguage.text.title} {publisherName}
            </h1>
            <LanguageSelector />
      </div>
    )
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps)(Header);